var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6235 16.5V18.75H6.37354V16.5H5.24854V18.75C5.24854 19.0484 5.36706 19.3345 5.57804 19.5455C5.78902 19.7565 6.07517 19.875 6.37354 19.875H17.6235C17.9219 19.875 18.2081 19.7565 18.419 19.5455C18.63 19.3345 18.7485 19.0484 18.7485 18.75V16.5H17.6235ZM17.6235 10.875L16.8304 10.0819L12.561 14.3456V4.125H11.436V14.3456L7.16666 10.0819L6.37354 10.875L11.9985 16.5L17.6235 10.875Z",
    fill: "#585960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.69f9e08ee968414aefe6eb7c9e6ca2b9.svg";
export { ForwardRef as ReactComponent };